import { apiFetch, type ApiResponse } from '@/src/api/apiService';
import { API_ENDPOINTS } from '@/src/api/config';

/**
 * Request a phone verification OTP
 */
export const requestPhoneVerificationCode = async (
  phoneNumber: string
): Promise<ApiResponse<{ message: string; cooldown_seconds?: number }>> => {
  try {
    const response = await apiFetch<{ message: string; cooldown_seconds?: number }>(
      API_ENDPOINTS.PHONE_REQUEST_OTP,
      {
        method: 'POST',
        body: JSON.stringify({ phone_number: phoneNumber }),
      },
      true,
      false
    );

    return response;
  } catch {
    return {
      ok: false,
      status: 0,
      data: { message: 'Network error' } as any,
    };
  }
};

/**
 * Confirm phone verification with OTP
 */
export const confirmPhoneVerificationCode = async (
  phoneNumber: string,
  code: string
): Promise<ApiResponse<{ message?: string; phone_number?: string }>> => {
  try {
    const response = await apiFetch<{ message?: string; phone_number?: string }>(
      API_ENDPOINTS.PHONE_CONFIRM_OTP,
      {
        method: 'POST',
        body: JSON.stringify({ phone_number: phoneNumber, code }),
      },
      true,
      false
    );

    return response;
  } catch {
    return {
      ok: false,
      status: 0,
      data: { detail: 'Network error' } as any,
    };
  }
};
